import { InjectionToken } from '@angular/core';
import { AppVersion } from './app-version.interface';

export const ClientManagerInstanceToken = new InjectionToken<ClientManagerInterface>('ClientManagerInterface');

export interface ClientManagerInterface {
    userCountry: string;
    getAppVersion: () => string;
    getCurrentAppId: () => string;
    isNgmP58: () => boolean;
    isNgmChina: () => boolean;
    isNgmP58CHNL: () => boolean;
    isNgmP58Switzerland: () => boolean;
    isNgmP58Netherlands: () => boolean;
    isNgmP58Austria: () => boolean;
    isNgmP58Finland: () => boolean;
    isNgmP58Bulgaria: () => boolean;
    getWeekdayFormat: () => string;
    getCurrentEnvironment: () => string;
    getDateFormat: (short?: boolean) => string;
    getTimeFormat: () => string;
    isPaceFormsFI: () => boolean;
    isPaceFormsForAuthors: () => boolean;
    getDateTimeFormat: (short?: boolean) => string;
    getTimeWithSecondsFormat: () => string;
    isPaceFormsForEvo: () => boolean;
    getBundleIdentifier: () => string;
    isPacePWA: () => boolean;
    isPacePWABrowser: () => boolean;
    isPacePWAStandalone: () => boolean;

    /**
     * Checks if the app is running on an iOS device.
     *
     * @returns {boolean} True if the application is running on an iOS device, otherwise false.
     */
    isPlatformIOS: () => boolean;

    /**
     * Checks if the app is running on a macOS system.
     *
     * @returns {boolean} True if the application is running on macOS, otherwise false.
     */
    isPlatformMacOS: () => boolean;

    version: AppVersion;
}

export enum SharpServiceNames {
    PACE = 'PACE',
    PACE_P58 = 'PACE P58',
    PACE_ASIA = 'PACE ASIA',
    PACE_AP1 = 'PACE AP1',
    PACE_ONLINE = 'PACE ONLINE',
    PACE_ONLINE_AA = 'PACE ONLINE AA',
    PACE_USA = 'PACE USA',
    PACE_FORMS_EVO = 'PACE Forms eVO',
    PACE_FORMS_FI = 'PACE FORMS FI',
}
